





































































































































import {
  GroupsApi,
  PermissionDto,
  PermissionModel,
  UserModel,
} from "../../../apis";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class PerrmissionManagement extends Vue {
  permissions: any[] = [];
  permissionsChild: any[] = [];

  created() {
    const { id } = this.$route.params;
    new GroupsApi().getUsersByGroup({ id }).then((resp) => {
      const groups = resp.data.data;
      if (groups.length > 0) {
        this.$store.commit("SET_BREADCUMB", {
          title: `${this.$t(`page.group.${groups[0].code}`)}`,
        });
      }
    });
    this.getPermissions();
  }

  get PERMISSIONS() {
    return this.$util.getConfig().settings.permissions;
  }

  async getPermissions() {
    try {
      this.$util.showLoading();
      const { id } = this.$route.params;
      const rs = await new GroupsApi().getPermissionsByGroup({ id });
      if (rs.status !== 200 || !rs.data.data) {
        return;
      }
      const keys = Object.keys(this.PERMISSIONS);
      // Sort permissions: existing ones first (by config order), new ones at the end
      const permissions = this.lodash.sortBy(rs.data.data, (val) => {
        const index = this.lodash.findIndex(keys, (item) => item === val.code);
        // If not found in config, put at the end (use a large number)
        return index === -1 ? 9999 : index;
      });
      this.permissions = permissions
        .filter((val) => !val.code.includes("|"))
        .map((val) =>
          Object.assign({}, { ...val }, { action: val.action.split("|") })
        );
      this.permissionsChild = permissions
        .filter((val) => val.code.includes("|"))
        .map((val) =>
          Object.assign(
            {},
            { ...val },
            { value: val.action.includes("update") }
          )
        );
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  getChild({ code }: { code: string }) {
    return this.permissionsChild.filter((val) => val.code.startsWith(`${code}|`));
  }

  get orphanChildPermissions() {
    // Find child permissions that don't have a parent in the permissions list
    if (!this.permissions || !this.permissionsChild) {
      return [];
    }
    const parentCodes = this.permissions.map(p => p.code);
    return this.permissionsChild.filter((child) => {
      if (!child || !child.code || !child.code.includes('|')) {
        return false;
      }
      const parentCode = child.code.split('|')[0];
      return !parentCodes.includes(parentCode);
    });
  }

  onChkClick(_event, _permission, _action) {
    this.updatePermissionList(_permission.id, _event, _action);
  }

  updatePermissionList(id: string, enable: boolean, _action: string) {
    const permistionSelected = this.permissions.filter((p) => p.id === id)[0];
    const indexOfAction = permistionSelected.action.indexOf(_action);
    if (enable) {
      permistionSelected.action.push(_action);
      if (_action !== "read") {
        permistionSelected.action.push("read");
      }
    } else {
      if (_action === "read") {
        permistionSelected.action = [];
      } else {
        permistionSelected.action.splice(indexOfAction, 1);
      }
    }
    // remove duplicate
    permistionSelected.action = permistionSelected.action.filter(
      (item, pos) => {
        return permistionSelected.action.indexOf(item) == pos;
      }
    );
  }

  async onSave() {
    this.$util.showLoading();
    try {
      const { id } = this.$route.params;
      let permissions = this.permissions.map((val) => {
        return {
          functionId: val.id,
          action: this.lodash.join(val.action, "|"),
        } as PermissionDto;
      });
      permissions = permissions.concat(
        this.permissionsChild.map((val) => {
          return {
            functionId: val.id,
            action: val.value ? this.lodash.join(this.actions, "|") : "",
          } as PermissionDto;
        })
      );
      await new GroupsApi().putDoUpdatePermissions({
        id,
        putPermissionsRequest: { permissions },
      });
      this.getPermissions();
    } catch (error) {
    } finally {
      this.$util.hideLoading();
    }
  }

  onCancel() {
    return this.$router.push("/users/groups");
  }

  actions = ["create", "read", "update", "delete"];

  get me() {
    return this.$store.getters.user as UserModel;
  }
}
